import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTime = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_10377_21568)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M11.4445 9.33417L8.80078 7.57166V3.9998H7.20078V8.42795L10.557 10.6654L11.4445 9.33417Z",
				fill: "black",
				fillOpacity: .87
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0.800781 7.9998C0.800781 4.03078 4.03176 0.799805 8.00078 0.799805C11.9698 0.799805 15.2008 4.03078 15.2008 7.9998C15.2008 11.9688 11.9698 15.1998 8.00078 15.1998C4.03176 15.1998 0.800781 11.9688 0.800781 7.9998ZM13.6008 7.9998C13.6008 4.90114 11.0994 2.3998 8.00078 2.3998C4.90211 2.3998 2.40078 4.90114 2.40078 7.9998C2.40078 11.0985 4.90211 13.5998 8.00078 13.5998C11.0994 13.5998 13.6008 11.0985 13.6008 7.9998Z",
				fill: "black",
				fillOpacity: .87
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_10377_21568",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgTime);
export { ForwardRef as ReactComponent };
